import { Component, OnInit } from "@angular/core";
import { Location } from "@angular/common";

@Component({
    selector: "app-privacy-page",
    templateUrl: "./privacy-page.component.html",
    styleUrls: ["./privacy-page.component.scss"],
    standalone: false,
})
export class PrivacyPageComponent {
    constructor(private location: Location) {}
    public email = "contact@udmglobal.com";

    public goBack() {
        this.location.back();
    }
}
